import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconPrinter = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--printer")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M18,1 C18.5522847,1 19,1.44771525 19,2 L19,2 L19,8 L20,8 C21.5976809,8 22.9036609,9.24891996 22.9949073,10.8237272 L23,11 L23,16 C23,17.6568542 21.6568542,19 20,19 L20,19 L19,19 L19,22 C19,22.5522847 18.5522847,23 18,23 L6,23 C5.44771525,23 5,22.5522847 5,22 L5,19 L4,19 C2.40231912,19 1.09633912,17.75108 1.00509269,16.1762728 L1,16 L1,11 C1,9.34314575 2.34314575,8 4,8 L4,8 L5,8 L5,2 C5,1.48716416 5.38604019,1.06449284 5.88337887,1.00672773 L6,1 Z M17,15 L7,15 L7,21 L17,21 L17,15 Z M20,10 L4,10 C3.44771525,10 3,10.4477153 3,11 L3,11 L3,16 C3,16.5522847 3.44771525,17 4,17 L4,17 L5,17 L5,14 C5,13.4477153 5.44771525,13 6,13 L18,13 C18.5522847,13 19,13.4477153 19,14 L19,17 L20,17 C20.5128358,17 20.9355072,16.6139598 20.9932723,16.1166211 L21,16 L21,11 C21,10.4477153 20.5522847,10 20,10 L20,10 Z M17,3 L7,3 L7,8 L17,8 L17,3 Z" id="icon--centivo--printer"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1663.000000, -973.000000)"/>
          <g id="Icon/printer">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--printer"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--printer"/>
          </g>
      </g>
  </IconWrapper>
)
